import { render, staticRenderFns } from "./AddResourceType.vue?vue&type=template&id=a7838e3e&scoped=true&"
import script from "./AddResourceType.vue?vue&type=script&lang=js&"
export * from "./AddResourceType.vue?vue&type=script&lang=js&"
import style0 from "./AddResourceType.vue?vue&type=style&index=0&id=a7838e3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7838e3e",
  null
  
)

export default component.exports